const VERSION = "0.9.6";

export default VERSION;
